<template>
  <footer>
    <a href="https://miltondavid.com" target="_blank" rel="noopener">
      miltondavid.com
    </a>
    <p>minhamola @ 2021 - {{ currentYear }}</p>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
footer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: 5rem;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
  justify-content: center;
  font-size: 0.85rem;
}

p,
a {
  text-align: center;
  color: var(--color-white);
}

a,
a:visited {
  padding-top: 1rem;
}

p {
  padding-bottom: 1rem;
  color: #bbb;
}
</style>
